module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_4_8.b9984272.jpeg";